import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { useScheduledCallsStartButtonPresenter } from './ScheduledCallsStartButton.presenter';
import styles from './ScheduledCallsStartButton.styles.m.css';

interface IScheduledCallsStartButtonProps {
  groupId: string;
  initiatorId: string;
  startTs: number;
  onClick?(): void;
}

export const ScheduledCallsStartButton: FC<IScheduledCallsStartButtonProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useScheduledCallsStartButtonPresenter(props);
  return (
    <Button
      className={styles.startButton}
      theme="primary"
      rounding={'1'}
      onClick={presenter.onButtonClick}
    >
      {t(presenter.group?.hasCall ? 'calls_join' : 'start_button')}
    </Button>
  );
});
